export default "__VITE_ASSET__BknRaPZM__"